import { useQuery } from 'react-query';
import customAxios from '../../../axios/custom-axios';

const getOrders = async param => {
  const token = localStorage.getItem('token');
  return customAxios({
    method: 'get',
    url: `/orders/${param}`,
    headers: { Authorization: `Bearer ${token}` },
  });
};

const useGetOrders = param => useQuery(['orders', param], () => getOrders(param));

export default useGetOrders;
